import React, { useState } from 'react';
import { Search, SlidersHorizontal, ChevronDown, ChevronUp } from 'lucide-react';

const FAQTab = () => {
  const [activeCategory, setActiveCategory] = useState('general');
  const [openAccordion, setOpenAccordion] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');

  const categories = [
    { id: 'general', label: 'General' },
    { id: 'vr', label: 'VR' },
    { id: 'games', label: 'Games' },
    { id: 'others', label: 'Others' }
  ];

  const faqs = [
    {
      question: 'How many games do I have access to?',
      answer: 'The YoGamezXR portal has multiple games to choose from and the games will be updated from time to time. The scores you get from each game that you play will be aggregated to your profile. Prizes are determined by the promoters.'
    },
    {
      question: 'How many chances will I get to play the games each day?',
      answer: 'You can play the games as many times as you want each day as long as you are subscribed to the service.'
    },
    {
      question: 'How will I claim or get the prizes that I win?',
      answer: 'Airtime prizes will be automatically disbursed into the User\'s mobile number that is subscribed to the service. Physical prizes if applicable will be communicated to the winner via our contact centre and arrangements will be made with the winner/s.'
    },
    {
      question: 'What prizes do I stand a chance to win?',
      answer: 'Prizes are determined by the promotion running at the time.'
    },
    {
      question: 'How do I access the portal?',
      answer: 'By subscribing via *773# or via the portal https://yogamezxr.econet.co.zw/'
    },
    {
      question: 'How do I unsubscribe?',
      answer: 'By dialling *773# or via the portal https://yogamezxr.econet.co.zw/ and following the prompts.'
    },
    {
      question: 'Am I charged to access the service?',
      answer: null,
      hasTable: true
    }
  ];

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  const filteredFaqs = faqs.filter(faq =>
    faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (faq.answer && faq.answer.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  return (
    <div className="px-6 pt-8 pb-6">
      {/* Category Buttons */}
      <div className="flex gap-3 mb-8 flex-wrap">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => setActiveCategory(category.id)}
            className={`px-6 py-3 rounded-full text-base font-medium transition-all ${
              activeCategory === category.id
                ? 'bg-[#00D9FF] text-black'
                : 'bg-transparent text-[#00D9FF] border-2 border-[#00D9FF]'
            }`}
          >
            {category.label}
          </button>
        ))}
      </div>

      {/* Search Bar */}
      <div className="mb-8 relative">
        <div className="bg-white rounded-lg flex items-center px-5 py-4">
          <Search className="w-5 h-5 text-gray-400 mr-3" />
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="flex-1 bg-transparent outline-none text-gray-700 text-base"
          />
          <SlidersHorizontal className="w-5 h-5 text-[#00D9FF] cursor-pointer" />
        </div>
      </div>

      {/* FAQ Accordions */}
      <div className="space-y-5">
        {filteredFaqs.map((faq, index) => (
          <div key={index} className="bg-white rounded-lg overflow-hidden">
            <button
              onClick={() => toggleAccordion(index)}
              className="w-full px-5 py-5 flex items-center justify-between text-left"
            >
              <span className="text-[#00D9FF] font-medium text-lg">
                {faq.question}
              </span>
              {openAccordion === index ? (
                <ChevronUp className="w-6 h-6 text-[#00D9FF] flex-shrink-0 ml-3" />
              ) : (
                <ChevronDown className="w-6 h-6 text-[#00D9FF] flex-shrink-0 ml-3" />
              )}
            </button>
            {openAccordion === index && (
              <div className="px-5 pb-5">
                {faq.answer && (
                  <p className="text-gray-600 text-base leading-relaxed">
                    {faq.answer}
                  </p>
                )}
                {faq.hasTable && (
                  <>
                    <p className="text-gray-600 text-base leading-relaxed mb-4">
                      Yes, see prices below. Renewals are done depending on which pack a user is subscribed to.
                    </p>
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="border-b border-gray-200">
                          <th className="text-left py-2 pr-4 text-gray-500 font-semibold">Pack</th>
                          <th className="text-left py-2 pr-4 text-gray-500 font-semibold">USD</th>
                          <th className="text-left py-2 text-gray-500 font-semibold">ZWG</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="border-b border-gray-100">
                          <td className="py-3 pr-4 text-gray-700 font-medium">Daily</td>
                          <td className="py-3 pr-4 text-gray-600">$0.08</td>
                          <td className="py-3 text-gray-600">ZWG 3.00</td>
                        </tr>
                        <tr className="border-b border-gray-100">
                          <td className="py-3 pr-4 text-gray-700 font-medium">Weekly</td>
                          <td className="py-3 pr-4 text-gray-600">$0.30</td>
                          <td className="py-3 text-gray-600">ZWG 15.00</td>
                        </tr>
                        <tr>
                          <td className="py-3 pr-4 text-gray-700 font-medium">Monthly</td>
                          <td className="py-3 pr-4 text-gray-600">$0.98</td>
                          <td className="py-3 text-gray-600">ZWG 45.00</td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQTab;